<template>
  <tbody
    v-if="fileChanges"
    @copy.prevent="onCopy"
  >
    <commit-diff-item-line
      v-for="line in fileChanges.lines"
      :key="line.id"
      :line="line"
      :has-discussions="hasDiscussions"
      @submitDiscussion="submitDiscussion($event, line)"
      @submitReply="submitReply($event, line)"
      @closeDiscussion="closeDiscussion"
    />
    <empty-listing
      v-if="fileChanges && fileChanges.lines && !fileChanges.lines.length"
      :title="$t('message.file_no_content')"
      :is-bordered="false"
    />
  </tbody>
  <div
    v-else
    class="position-relative p-5"
  >
    <pacman-loader />
  </div>
</template>

<script>
import RepoS from '@shared/services/repository.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import EmptyListing from '@shared/shared-components/empty-listing';
// eslint-disable-next-line import/no-unresolved
import CommitDiffItemLine from './commit-diff-item-line';

export default {
  name: 'CommitDiffItem',
  components: { CommitDiffItemLine, PacmanLoader, EmptyListing },
  props: {
    file: Object,
    alias: String,
    projectAlias: String,
    commitId: String,
    mergeRequest: Object,
    hasDiscussions: {
      default: false,
      type: Boolean
    },
    isCommitDiffPage: {
      default: null,
      type: Boolean
    },
    sourceCommit: {
      default: null,
      type: String
    },
    targetCommit: {
      default: null,
      type: String
    }
  },
  data() {
    return { fileChanges: null };
  },
  mounted() {
    if (this.file.lines && this.file.lines.length > 0) {
      this.fileChanges = { lines: this.file.lines };
      return;
    }
    const params = { filePath: encodeURIComponent(this.file.filePath) };
    if (this.file.ignoreCollapsed) {
      params.ignoreCollapsed = this.file.ignoreCollapsed;
    }

    if (this.mergeRequest?.sourceBranch?.hash && this.mergeRequest?.targetBranch?.hash) {
      params.compareHash = this.mergeRequest.sourceBranch.hash;
      params.baseHash = this.mergeRequest.targetBranch.hash;

      RepoS.getMergeRequestDiffLines(this.alias, this.projectAlias, this.commitId, {
        ...params
      }).then((res) => {
        if (res[this.file?.id]) this.fileChanges = res[this.file?.id][0];
        else this.fileChanges = {};
      });
    } else if (this.isCommitDiffPage && this.sourceCommit && this.targetCommit) {
      params.compareHash = this.targetCommit;
      params.baseHash = this.sourceCommit;
      RepoS.getMergeRequestDiffLines(this.alias, this.projectAlias, this.commitId, {
        ...params
      }).then((res) => {
        if (res[this.file?.id]) this.fileChanges = res[this.file?.id][0];
        else this.fileChanges = {};
      });
    } else {
      RepoS.getCommitDiffLines(this.alias, this.projectAlias, this.commitId, {
        ...params
      }).then((res) => {
        this.fileChanges = res;
      });
    }
  },
  methods: {
    submitDiscussion(data, line) {
      this.$emit('submitDiscussion', { data, line, file: this.file });
    },
    submitReply(data, line) {
      this.$emit('submitReply', { ...data, line });
    },
    closeDiscussion(data) {
      this.$emit('closeDiscussion', data);
    },
    onCopy(e) {
      e.clipboardData.setData('text/plain', document.getSelection());
      e.preventDefault();
    }
  }
};
</script>
